import { z } from 'zod'

export const CLICK_EVENT_TIMEOUT = 200 as const
export const ERROR_EVENT_TYPE = 'error' as const
export const PAGE_RENDERED_EVENT_NAME = 'page-rendered' as const

export const OrganisationEnum = z.enum(['mmt', 'gi'])
export const EntityEnum = z.enum(['india', 'global'])
export const RegionEnum = z.enum(['in', 'ae', 'sa'])
export const CurrencyEnum = z.enum(['inr', 'usd', 'aed', 'sar'])
export const UserLanguageEnum = z.enum(['eng', 'hin', 'tam', 'ara'])
export const ProfileTypeEnum = z.enum(['personal', 'business', 'cta', 'affiliates'])
export const PlatformEnum = z.enum(['desktop', 'pwa', 'mobile'])
export const OsEnum = z.enum([
  'android',
  'ios',
  'mac os',
  'windows',
  'linux',
  'blackberry',
  'symbian',
  'nokia',
  'webos',
  'unix',
  'samsung',
  'other',
])
export const PageTypeEnum = z.enum(['landing', 'funnel', 'template', 'promo'])
export const FunnelStepEnum = z.enum(['landing', 'listing', 'detail', 'review', 'payment', 'thankyou'])
export const LobEnum = z.enum([
  'common',
  'flights',
  'hotels',
  'bus',
  'rails',
  'cabs',
  'holidays',
  'travelinsurance',
  'forex',
  'giftcards',
  'visa',
  'w2g',
  'acme',
  'how2go',
  'travelcard',
  'hostapp',
  'postsales',
])
export const LobCategoryEnum = z.enum([
  'common',
  'df',
  'if',
  'dh',
  'ih',
  'bus',
  'rails',
  'dom_acabs',
  'dom_ocabs',
  'dom_hrcabs',
  'intl_acabs',
  'intl_ocabs',
  'intl_hrcabs',
  'domhld',
  'intlhld',
  'travelinsurance',
  'forex',
  'pc',
  'cn',
  'nc',
  'giftcards',
  'e-visa',
  'sticker-visa',
  'w2g',
  'dom_acme',
  'intl_acme',
  'how2go',
  'travelcard',
  'hostapp',
])
export const EventNameEnum = z.enum([
  PAGE_RENDERED_EVENT_NAME,
  ERROR_EVENT_TYPE,
  'search-clicked',
  'sort_by-clicked',
  'filter-applied',
  'filter_all-cleared',
  'content_card_filter-clicked',
  'content_header-filter-clicked',
  'map_filter-clicked',
  'product_card_filter-clicked',
  'popup-rendered',
  'login-succeeded',
  'user-logged-out',
  'signup-completed',
  'chat-interacted',
  'send-quote',
  'price-change',
])
